"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LogMetadata;

(function (LogMetadata) {
  LogMetadata.EMPTY_METADATA = {
    service: "universe-log-no-metadata"
  };

  function getBestIdentifier(metadata) {
    var ident = metadata.service ? "".concat(metadata.service, ".") : metadata.project ? "".concat(metadata.project, ".") : "";
    ident += metadata.module ? "".concat(metadata.module, ".") : "";
    ident += metadata.library ? "[".concat(metadata.library, "].") : "";
    ident += metadata.name || "";
    if (!ident) ident = "universe-log-empty-id";
    return ident;
  }

  LogMetadata.getBestIdentifier = getBestIdentifier;
})(LogMetadata = exports.LogMetadata || (exports.LogMetadata = {}));